import {
  CustomViewAttribute,
  CustomViewFormConditionField,
} from 'src/graphql/entities/custom-view/custom-view.types';

const AI_SITE_SUMMARY_ATTRIBUTES = new Set(['siteHealth', 'siteSentiment']);

/**
 * Strips AI site-summary columns and filters from a custom view entity config
 * when the user does not have AccessToAiSiteSummary. Same shape as
 * filterServiceLevelAttributes.
 */
export function filterAiSiteSummaryAttributes<
  T extends {
    attributesList: CustomViewAttribute[];
    attributesMap: Map<string, CustomViewAttribute>;
    filterAttributesList: CustomViewFormConditionField[];
    filterAttributesMap: Map<string, CustomViewFormConditionField>;
  },
>(config: T, hasAiSiteSummaryAccess: boolean): T {
  if (hasAiSiteSummaryAccess) return config;

  const attributesList = config.attributesList.filter(
    (attr) => !AI_SITE_SUMMARY_ATTRIBUTES.has(attr.attribute),
  );

  const attributesMap = new Map(config.attributesMap);
  for (const key of AI_SITE_SUMMARY_ATTRIBUTES) {
    attributesMap.delete(key);
  }

  const filterAttributesList = config.filterAttributesList.filter(
    (attr) => !AI_SITE_SUMMARY_ATTRIBUTES.has(attr.value),
  );

  const filterAttributesMap = new Map(config.filterAttributesMap);
  for (const key of AI_SITE_SUMMARY_ATTRIBUTES) {
    filterAttributesMap.delete(key);
  }

  return {
    ...config,
    attributesList,
    attributesMap,
    filterAttributesList,
    filterAttributesMap,
  };
}
